"use client";

import React, { useState } from "react";
import "./CoursePage/Course.css";
import "./Corporate.css";
import Avatar from "@mui/material/Avatar";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
// MUI's <Avatar src> preloads the image through a JS `new Image()`, so loading="lazy" cannot be applied
// to it and every trainer photo (~100 on /courses, 36-68 KB each) downloaded immediately. The photo is
// rendered as a native lazy <img> inside the Avatar instead (same circle/size styling via MuiAvatar-img);
// a missing or failing image falls back to the plain Avatar exactly as before.
const TrainerAvatar = ({ name, src }) => {
  const [failed, setFailed] = useState(false);
  if (!src || failed) return <Avatar alt={name} className="profile-image" />;
  return (
    <Avatar className="profile-image" sx={{ bgcolor: "transparent" }}>
      <img className="MuiAvatar-img" src={src} alt={name} loading="lazy" decoding="async" onError={() => setFailed(true)} />
    </Avatar>
  );
};

import { MdStar, MdStarHalf, MdStarBorder } from "react-icons/md";

// Ported from the CRA app's src/Components/UserPanel/InstructorCard.jsx.
const InstructorCard = (props) => {
  const [open, setOpen] = useState(false);

  const renderStarRating = (rating) => {
    const r = Math.max(0, Math.min(5, parseFloat(rating) || 0));
    const full = Math.floor(r);
    const half = r - full >= 0.5 ? 1 : 0;
    const empty = 5 - full - half;

    return (
      <>
        {[...Array(full)].map((_, i) => (
          <MdStar key={`f${i}`} className="star-icon filled-star" title={`${r} / 5`} />
        ))}
        {half === 1 && <MdStarHalf className="star-icon filled-star" title={`${r} / 5`} />}
        {[...Array(empty)].map((_, i) => (
          <MdStarBorder key={`e${i}`} className="star-icon empty-star" title={`${r} / 5`} />
        ))}
      </>
    );
  };

  const getTruncatedText = (html, limit = 150) => {
    if (!html) return "";
    if (typeof document === "undefined") return "";
    const temp = document.createElement("div");
    temp.innerHTML = html;
    const text = temp.textContent || temp.innerText || "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  return (
    <>
      <div className="trainer-card">
        <div className="trainer-top">
          <div className="learner-image">
            <TrainerAvatar name={props.trainer_name} src={props.profileImage} />
          </div>
        </div>
        <div className="learner-info">
          <div className="learner-name">
            <p className="name">{props.trainer_name}</p>
          </div>
          <p className="job-profile">{props.profile}</p>
          <div className="rating">{renderStarRating(props.trainerUserRating)}</div>
        </div>
      </div>

      <hr className="faq-seperater" />
      <div className="trainer-description-bottom">
        <p className="learner-description">
          {getTruncatedText(props.summary, 150)}
          <span
            className="read-more"
            onClick={() => setOpen(true)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") setOpen(true);
            }}
          >
            {" "}
            Read More
          </span>
        </p>
      </div>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle className="top">
          About Trainer {props.trainer_name}
          <IconButton aria-label="close" onClick={() => setOpen(false)} className="close-button">
            <CloseIcon style={{ color: "#3d3d3d", background: "none", borderRadius: "50%" }} />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <div className="trainer-popup-content">
            <div className="trainer-top">
              <div className="learner-image">
                <TrainerAvatar name={props.trainer_name} src={props.profileImage} />
              </div>
            </div>
            <div className="learner-info">
              <div className="learner-name">
                <p className="name">{props.trainer_name}</p>
              </div>
              <p className="job-profile">{props.profile}</p>
              <div className="rating">{renderStarRating(props.trainerUserRating || props.trainerRating)}</div>
            </div>
          </div>

          <hr className="faq-seperater" />
          <div className="trainer-description-bottom">
            <div
              className="full-review"
              dangerouslySetInnerHTML={{
                __html: props.summary?.trim() || "This trainer is highly skilled and has helped many students achieve their goals.",
              }}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default InstructorCard;
